import React from "react";
import { MDBTypography } from "mdb-react-ui-kit";
import "./Typography.css";
const Typography = () => {
  return (
    <div className="typo">
      <MDBTypography note noteColor="primary">
        <strong>مهم : </strong> این سایت دمویی از سایت کامل است که از تیم آپادانا قابل سفارش است، این سایت با زبان های ری اکت و پایتون نوشته شده است. <br /> برای دریافت جواب از سمت سرور باید با فیلترشکن روشن وارد بخش ها شوید.
      </MDBTypography>
    </div>
  );
};

export default Typography;
